function checkIsChangelog(path) {
  return path.indexOf('changelog') > -1
}

module.exports = { checkIsChangelog }
